export default __webpack_public_path__ + "static/media/btn_depart.d5a0b25a.svg";